import { useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { ToastContainer } from "react-toastify";

export default function BankLst({
  item,
  deletePaymentMethod,
  isPaymentMethodDeleted,
  handleChangeDefaultPaymentMethod,
  isPaymentMethodDefault = false,
}) {
  const dispatch = useDispatch();
  const onDelete = (payment_method_id) => {
    dispatch(
      deletePaymentMethod({
        payment_method_id: payment_method_id,
      })
    );
  };
  const [popup, setPopup] = useState({
    show: false,
    payment_method_id: null,
  });
  return (
    <div className="lst">
      <ul>
        <li>
          <h6>Bank Name</h6>
          <p>{item?.bank_name}</p>
        </li>
        <li>
          <h6>Account Title</h6>
          <p>{item?.card_holder_name}</p>
        </li>
        <li>
          <h6>Account Number</h6>
          <p>**********{item?.card_number}</p>
        </li>
        <li>
          <h6>Swift/Routing #</h6>
          <p>{item?.routing_number}</p>
        </li>
        <li>
          <h6>Account Type</h6>
          {item?.account_type === "C" ? (
            <span className="badge green">Checking Account</span>
          ) : (
            <span className="badge blue">Savings Account</span>
          )}
        </li>
        <li>
          <h6>Status</h6>
          {item?.is_default === 1 ? (
            <span class="badge green">Default</span>
          ) : (
            <span class="badge" onClick={()=>handleChangeDefaultPaymentMethod(item?.encoded_id)}>Make Default</span>
          )}
        </li>
        <li className="bTn">
          <NavLink
            to={"/edit-bank-details/" + item?.encoded_id}
            className="webBtn labelBtn blue-color"
          >
            Edit
          </NavLink>
          <a
            href="javascript:void(0)"
            onclick="return confirm('Are you sure?');"
            className="webBtn labelBtn red-color"
            onClick={() =>
              setPopup({ show: true, payment_method_id: item?.encoded_id })
            }
          >
            Delete
          </a>
        </li>
      </ul>
      {popup?.show === true &&
      popup?.payment_method_id !== null &&
      popup?.payment_method_id !== undefined &&
      popup?.payment_method_id !== "" ? (
        <div index className="popup small_popup">
          <div className="tableDv">
            <div className="tableCell">
              <div className="_inner">
                <ToastContainer />
                <div
                  className="crosBtn"
                  onClick={() =>
                    setPopup({ show: false, payment_method_id: null })
                  }
                ></div>
                <h4>Are you sure you want to delete this?</h4>
                <div className="bTn text-center">
                  <NavLink
                    to="#!"
                    className="webBtn"
                    onClick={() => onDelete(popup?.payment_method_id)}
                    disabled={isPaymentMethodDeleted}
                  >
                    Yes{" "}
                    {isPaymentMethodDeleted ? <i className="spinner"></i> : ""}
                  </NavLink>
                  <NavLink
                    to="#!"
                    className="webBtn"
                    onClick={() =>
                      setPopup({ show: false, payment_method_id: null })
                    }
                  >
                    No
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
